import { Add } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import backIcon from "./../../images/back-icon.svg";
import { useStyles } from "./styles";

const SimpleWidgetsHeader = ({ onClose, title, Icon, action, actions }) => {
    const classes = useStyles();
    const actionsList = actions || (action ? [action] : []);

    return (
        <div className={classes.Header}>
            {onClose && (
                <IconButton onClick={() => onClose?.()} className="BackBtn">
                    <img src={backIcon} />
                </IconButton>
            )}
            <div className={classes.Details}>
                <div className="HeaderIcon"> {Icon && <Icon />}</div>
                <div className="HeaderTitle">
                    <div>{title}</div>
                </div>
                {actionsList.map((a, idx) =>
                    a?.label ? (
                        <Button
                            key={`header-action-${idx}`}
                            size="small"
                            variant="contained"
                            onClick={a.callback}
                            startIcon={a.Icon ? <a.Icon /> : <Add />}
                            sx={{ marginLeft: "0.5rem" }}
                        >
                            {a.label}
                        </Button>
                    ) : (
                        <IconButton
                            key={`header-action-${idx}`}
                            onClick={a.callback}
                        >
                            {a.Icon ? <a.Icon /> : <Add />}
                        </IconButton>
                    )
                )}
            </div>
        </div>
    );
};

export default SimpleWidgetsHeader;
